<template>
	<v-card flat color="transparent">
		<v-card-title primary-title dark class="white--text">
			{{ tenants.length }} Restaurants
		</v-card-title>
		<v-card-text>
			<v-container grid-list-xl class="pa-0">
				<v-layout row wrap>
					<v-flex
						class="d-flex flex-column"
						xs12
						md4
						v-for="(tenant, index) in tenants"
						:key="index"
					>
						<ShopTenantCard
							:tenant="tenant"
							:type="type"
						></ShopTenantCard>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import ShopTenantCard from "./ShopTenantCard.vue";
export default {
	components: {
		ShopTenantCard,
	},
	props: ["tenants", "type"],
};
</script>
